import React from "react";
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";
import ShareIconsInverted from "../icons/ShareIconsInverted";
import { copyToClipboard } from "../../utils/copyToClipboard";
import ArticleHeaderStyles from "../../styles/ArticleHeaderStyles";

const ArticleShareBottom = ({ currentUrl, data }) => {
  const { title } = data;

  const copyLink = () => {
    copyToClipboard(currentUrl);
  };

  return (
    <ArticleHeaderStyles>
      <div className="article__share-collection--bottom">
        <h4 className="article__share-header">Share this article</h4>
        <div className="article__share-collection mb-2">
          {" "}
          <div
            onClick={copyLink}
            className="article__share-item article__share-item--inverted"
          >
            <div className="article__share-item--copy">
              <ShareIconsInverted icon="copy" />
            </div>
          </div>
          <div className="article__share-item article__share-item--inverted">
            <TwitterShareButton
              children={
                <>
                  <div>
                    <ShareIconsInverted icon="twitter" />
                  </div>
                </>
              }
              title={title}
              url={`https://www.table-sage.com${currentUrl}`}
            />
          </div>
          <div className="article__share-item article__share-item--inverted">
            <FacebookShareButton
              children={
                <>
                  <div>
                    <ShareIconsInverted icon="facebook" />
                  </div>
                </>
              }
              quote={title}
              url={`https://www.table-sage.com${currentUrl}`}
            />
          </div>
          <div className="article__share-item article__share-item--inverted">
            <WhatsappShareButton
              id="whatsapp-btn"
              children={
                <>
                  <div>
                    <ShareIconsInverted icon="whatsapp" />{" "}
                  </div>
                </>
              }
              title={title}
              separator="&#x000D;"
              url={`https://www.table-sage.com${currentUrl}`}
            />
          </div>
        </div>
      </div>
    </ArticleHeaderStyles>
  );
};

export default ArticleShareBottom;
